import React from 'react'
import TooltipInfo from '../TooltipInfo'
import PropTypes from 'prop-types'
import FieldExtra from '../FieldExtra'
import './textArea.scss'

const TextArea = ({ className, error, warning, type, label, disabled, optional, info, infoProps, ...rest }) => {
  return <div className={`Suc-textarea ${disabled ? 'Suc-disabled' : ''} ${className}`}>
    <div className={'Suc-textarea-top'}>
      {label && <label className={'Suc-textarea-label'}>{label}</label>}
      <div className={'Suc-right-section'}>
        {optional && <span className={'Suc-optional'}>Optional</span>}
        {info && <TooltipInfo {...infoProps}>{info}</TooltipInfo>}
      </div>

    </div>
    <textarea className={'Suc-textarea-field'} disabled={disabled} {...rest} />
    <FieldExtra error={error} warning={warning}/>
  </div>
}

TextArea.propTypes = {
  /** disabled state */
  disabled: PropTypes.bool,
  /** custom classname */
  className: PropTypes.string,
  /** input label */
  label: PropTypes.string,
  /** input placeholder */
  placeholder: PropTypes.string,
  /** Is the field optional */
  optional: PropTypes.bool,
  /** info tooltip */
  info: PropTypes.node,
  /** InfoTooltip props */
  infoProps: PropTypes.object
}

TextArea.defaultProps = {
  className: '',
  optional: false,
  infoProps: {}
}

export default TextArea
